import React from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import { useBoolean } from '@fluentui/react-hooks';

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import CTextAreaSimple from '../../../Common/CTextAreaSimple';


function SidePanelViewCommentEvent(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_MessageEventObject = props.messageEventObject !== null && props.messageEventObject !== undefined ? props.messageEventObject : null;

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    

    //Funciones de componente.


    //Eventos de componente.


    const onClosePanel = () => {
        onDismissPanel();
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-neweventcomment') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col xl={12}>
                        <CTextAreaSimple labelText={ t('data-lang-lbl-body') } controlValue={ inputParam_MessageEventObject !== null ? inputParam_MessageEventObject.messageEventDesc : "" } setterControlValue={ null } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelViewCommentEvent;